import React from 'react';
import HeroSection from '../components/home/HeroSection';
import HadithSection from '../components/home/HadithSection';
import TajweedGuideSection from '../components/home/TajweedGuideSection';
import QuranMethodSection from '../components/home/QuranMethodSection';
import HowItWorksSection from '../components/home/HowItWorksSection';
import CourseLevelsSection from '../components/home/CourseLevelsSection';
import PricingSection from '../components/home/PricingSection';
import TestimonialsSection from '../components/home/TestimonialsSection';
import WhyUsSection from '../components/home/WhyUsSection';
import CTASection from '../components/home/CTASection';

const HomePage = () => {
  return (
    <div data-testid="home-page">
      <HeroSection />
      <div className="gold-divider"></div>
      <HadithSection />
      <QuranMethodSection />
      <TajweedGuideSection />
      <HowItWorksSection />
      <CourseLevelsSection />
      <WhyUsSection />
      <CTASection />
    </div>
  );
};

export default HomePage;
